import React from "react";
import { BaseSvgIcon, createIcon } from "../IconBase";
// GENERATED from custom/src/project.svg by scripts/generate-icons.mjs. Do not edit
// by hand — edit the source SVG and regenerate.
const ProjectIconGlyph = (props) => (React.createElement(BaseSvgIcon, { ...props },
    React.createElement("path", { d: "M2 18H9.27272V22H2V18ZM14.7273 18V22H22V18H14.7273ZM18.6156 11.4943L12.9091 11.5V7.74H17.6727V2H6.32337V7.74H11.0909V11.4943H4.72727V16.7414H6.54545V13.5857H12.4753L17.4545 13.5757V16.7414H19.2727V11.4843L18.6156 11.4943Z" })));
export const ProjectIcon = createIcon(ProjectIconGlyph, "ProjectIcon", "0 0 24 24");
//# sourceMappingURL=ProjectIcon.js.map